'use client';
class URLConstraintError extends Error {
    constructor(){
        super('`input` не может начинаться со `/` при использовании `prefixUrl`');
        Object.setPrototypeOf(this, URLConstraintError.prototype);
    }
}

export { URLConstraintError };
//# sourceMappingURL=URLConstraintError.js.map
